import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { UserManagement } from './UserManagement/UserManagement';
import { UploadScans } from './components/UploadScans';
import { SiteManagement } from './UserManagement/SiteManagement';
import { StudyManagement } from './UserManagement/StudyManagement';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { ScanTaggerTableView } from './components/ScanTaggerTableView';
import './scantaggerJS.css';

export default class App extends Component {

    static displayName = "Torana Transfer Website";
  
    render() {
        var scandtoId = '/scan/' + window.localStorage.getItem('scandtoId');
        return (
            <Layout>
                <AuthorizeRoute exact path='/' component={ScanTaggerTableView} />
                <AuthorizeRoute exact path={scandtoId} component={ScanTaggerTableView} />
                <AuthorizeRoute path='/UserManagement' component={UserManagement} />
                <AuthorizeRoute path='/UploadScans' component={UploadScans} />
                <AuthorizeRoute path='/SiteManagement' component={SiteManagement} />
                <AuthorizeRoute path='/StudyManagement' component={StudyManagement} />

                <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
            </Layout>
        );
    }
}